export const formatAddress = (address) => {
  if (!address) return 'None';

  const {
    address1: line1 = '',
    address2: line2 = '',
    city = '',
    state = '',
    zip = ''
  } = address || {};

  return line1 ? (
    <pre>
      {
        `${line1 || ''}
${line2 || ''}
${city ? `${city}, ` : ''}${state ? `${state} ` : ''}${zip || ''}`.replace(/\n+/g, '\n')
      }
    </pre>
  ) : 'None';
};

export const formatVBAAddress = (address) => {
  if (!address) return 'None';

  const {
    address1: line1 = '',
    address2: line2 = '',
    mailboxIdentifier = '',
    city = '',
    state = '',
    zip = ''
  } = address || {};

  return line1 ? (
    <pre>
      {
        `${line1 || ''},  ${line2 || ''},  #${(mailboxIdentifier || '').replace('PMB ', '')}
${city ? `${city}, ` : ''}${state ? `${state} ` : ''}${zip || ''}`.replace(/\n+/g, '\n')
      }
    </pre>
  ) : 'None';
};

export const formatContact = (contact) => {
  if (!contact) return 'None';

  const {
    companyName: company = '',
    firstName: first = '',
    middleName: middle = '',
    lastName: last = '',
    address1: line1 = '',
    address2: line2 = '',
    city = '',
    state = '',
    zip = '',
    phone = '',
    email = ''
  } = contact || {};

  return (
    <pre>
      {
        `${company || `${first ? `${first} ` : ''}${middle ? `${middle} ` : ''}${last || ''}`}
${line1 || ''}
${line2 || ''}
${city ? `${city}, ` : ''}${state ? `${state} ` : ''}${zip || ''}
${phone || ''}
${email || ''}`.replace(/\n+/g, '\n')
      }
    </pre>
  );
};
